import React from "react";

import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "reactstrap";
import { Link } from "react-router-dom";
import "./Login.scss";
import { useSelector,  } from "react-redux";
// import solarImg from '../../../../public/assets/img/solar-panel-login.jpg';
const Rememmber = () => {
  const lang_choiced = useSelector((state) => state.lang_change);

  // const dispatch = useDispatch();
 
    return (
      <div className="app flex-row align-items-center login-background">
        <Container>
          <Row className="justify-content-center" style={{}}>
            <Col sm="8" xl="4" md="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form>
                      <h1>{lang_choiced.pages.remmember.title}</h1>
                      <p className="text-muted">
                      {lang_choiced.pages.remmember.text}
                      </p>
                     
                      <InputGroup className="mb-4" style={{direction:'ltr'}}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          className="Input-setup"
                          type="email"
                          placeholder="EMAIL"
                          autoComplete="current-email"
                        />
                      </InputGroup>
                      <Row>
                        <Col xs="8">
                          <Link to="#">
                            <Button
                              style={{}}
                              color="primary"
                              className=" login-button"
                            >
                            {lang_choiced.pages.remmember.recovery}
                            </Button>
                          </Link>
                        </Col>
                        <Col xs="4" className="text-right">
                          <Link to="/login">
                            <Button color="link" className="text-right px-0">
                            {lang_choiced.pages.remmember.login}
                            </Button>
                          </Link>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  
}

export default Rememmber;
